import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;

const PREVIEW_CONTAINER_ID = "previewContainer";
const ARTICLE_SOURCE_LISTING_PAGE = "listingPage";
const ARTICLE_SOURCE_AUTHOR = "author";

export class vignettePreview_helper {
    protected XHRHdls: any = {};
    protected XHRHdlCaller: string;
    private vnAppZone: any;
    private callerModule: any;
    public validationTemplate: any;

    constructor(vnAppZone: any, callerModule: any) {
        this.vnAppZone = vnAppZone;
        this.callerModule = callerModule;
        this.validationTemplate = callerModule.validationTemplate;
    }

    public getVnAppZone(): any {
        return this.vnAppZone;
    }

    public manageResponse(req, obj, callback): void {
        this.callerModule.manageResponse(req, this.callerModule, callback);
    }

    /** Edit module exposes `editForm`; view module exposes `vignetteView`. */
    protected isEditSurface(): boolean {
        return !!(this.callerModule && this.callerModule.editForm);
    }

    protected getSurface(): any {
        const cm = this.callerModule;
        if (!cm) {
            return null;
        }
        if (cm.editForm) {
            return cm.editForm;
        }
        if (cm.vignetteView) {
            return cm.vignetteView;
        }
        if (cm.elementsEdit) {
            return cm.elementsEdit;
        }
        if (cm.elementView) {
            return cm.elementView;
        }
        return null;
    }

    protected getVignettePreview(): any {
        const surface = this.getSurface();
        return surface && surface["vignettePreview"] ? surface["vignettePreview"] : null;
    }

    protected getTagFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["tagFilter"] ? vp["tagFilter"] : null;
    }

    protected getArticleFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["articleFilter"] ? vp["articleFilter"] : null;
    }

    protected getVideoFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["videoFilter"] ? vp["videoFilter"] : null;
    }

    protected getListingPageFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["listingPageFilter"] ? vp["listingPageFilter"] : null;
    }

    protected getHubPageFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["hubPageFilter"] ? vp["hubPageFilter"] : null;
    }

    public insertImage(image, target, extra_option = null): void {
        const vp = this.getVignettePreview();
        if (vp && typeof vp.addIndexedImage === "function") {
            vp.addIndexedImage(image);
        }
    }

    protected getAuthorFilter(): any {
        const vp = this.getVignettePreview();
        return vp && vp["authorFilter"] ? vp["authorFilter"] : null;
    }

    //filter simple on change functions
    public filterSimpleOnChange(idElement) {
        switch (idElement) {
            case "tagFilter": {
                this.updateTagFilterSelectedValue();
                break;
            }
            case "articleFilter": {
                this.updateArticleFilterSelectedValue();
                break;
            }
            case "videoFilter": {
                this.updateVideoFilterSelectedValue();
                break;
            }
            case "listingPageFilter": {
                this.updateListingPageFilterSelectedValue();
                break;
            }
            case "hubPageFilter": {
                this.updateHubPageFilterSelectedValue();
                break;
            }
            case "authorFilter": {
                this.updateAuthorFilterSelectedValue();
                break;
            }
        }
    }

    //===============================================
    //article slot helpers shared by the listing page and author sources
    protected getManuallySelectedArticleIds(): string[] {
        const af = this.getArticleFilter();
        const selectedArticles = af && typeof af.getArticleObjs === "function" ? af.getArticleObjs() : [];

        return selectedArticles.map((article) => String(article.id));
    }

    /** Articles loaded from a listing page or an author accumulate, so only drop the ones of the cleared source. */
    protected removeArticlesFromSource(source: string): void {
        const vp = this.getVignettePreview();
        if (!vp) {
            return;
        }

        const manuallySelectedIds = this.getManuallySelectedArticleIds();
        const remainingArticles = vp.getAllSelectedArticles().filter((article) => {
            return article.previewSource !== source || manuallySelectedIds.indexOf(String(article.id)) !== -1;
        });

        vp.setAllSelectedArticles(remainingArticles);
        vp.setIndexedValuesForArticles(remainingArticles);
    }

    protected addArticlesFromSource(articles: any[], source: string): void {
        const vp = this.getVignettePreview();
        if (!vp || !Array.isArray(articles) || articles.length === 0) {
            return;
        }

        const sourcedArticles = articles.map((article) => {
            article.previewSource = source;
            return article;
        });

        const allArticles = [...vp.getAllSelectedArticles(), ...sourcedArticles];
        const uniqueArticles = allArticles.filter((article, index, self) =>
            index === self.findIndex((t) => t.id === article.id)
        );

        vp.setAllSelectedArticles(uniqueArticles);
        vp.setIndexedValuesForArticles(uniqueArticles);
    }

    //===============================================
    //tag autocomplete and preview tag functions
    public getTagsSuggestion(keyword, idElement) {
        if (this.XHRHdls["getTagsSuggestion"]) {
            this.XHRHdls["getTagsSuggestion"].cancelAndReset();
        }

        let filterPayload: any = { keyword: keyword, getNonSelectable: true };
        if (this.isEditSurface()){
            filterPayload = { ...filterPayload, getSelectable: true };
        }

        const subViewModel = { filter: filterPayload, idElement: idElement };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/search/tag/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getTagsSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getTagsSuggestion"].onReadyStateFunction = this.onGetTagsSuggestionReturn;
        this.XHRHdls["getTagsSuggestion"].execute();
    }

    public onGetTagsSuggestionReturn(req, obj) {
        if (!obj.callerModule || typeof obj.callerModule.manageResponse !== "function") {
            console.warn("vignettePreview_helper: callerModule.manageResponse missing.");
            return;
        }

        return function () {
            obj.callerModule.manageResponse(req, obj.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);

                if (responseParsed.data && responseParsed.data.tags) {
                    const tagFilter = obj.getTagFilter();
                    if (tagFilter && typeof tagFilter.setTags === "function") {
                        const tags = responseParsed.data.tags;
                        tagFilter.setTags(tags.map((tag) => {
                            tag.isSelectable = !!tag.isSelectable;
                            return tag;
                        }));
                    }
                }
            });
        };
    }

    public updateTagFilterSelectedValue() {
        const tf = this.getTagFilter();
        const vp = this.getVignettePreview();
        const selectedTags = tf && typeof tf.getTagObjs === "function" ? tf.getTagObjs() : [];
        const tagNeedingFetch = selectedTags.filter((tag) => tag && tag.id && !tag.isPreviewDataLoaded)[0];

        if (tagNeedingFetch) {
            this.getTagById(tagNeedingFetch.id, PREVIEW_CONTAINER_ID);
            return;
        }

        if (vp && typeof vp.setIndexedValuesForTags === "function") {
            vp.setIndexedValuesForTags(selectedTags);
        }
        if (tf && typeof tf.clearInput === "function") {
            tf.clearInput();
        }
    }

    public getTagById(idTag, idElement) {
        const cm = this.callerModule;
        const surface = this.getSurface();
        if (!idTag || !surface || !cm || typeof cm.loadingIn !== "function") {
            return;
        }

        cm.loadingIn(surface.builtTemplate.querySelector(`#${idElement}`));

        const idRequest = "getPreviewTagSpecs";
        const idBrand: string = this.vnAppZone.app.params.idBrand;

        if (this.XHRHdls[idRequest]) {
            this.XHRHdls[idRequest].cancelAndReset();
        }

        const usrReq_url: string = `/api/brand/${idBrand}/tags/get/${idTag}`;
        const usrReq_params: string[][] = [];

        this.XHRHdls[idRequest] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls[idRequest].onReadyStateFunction = this.onGetTagByIdReturn;
        this.XHRHdls[idRequest].execute();
    }

    public onGetTagByIdReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;

        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }

            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                const tag = responseParsed.tag;
                const specsValues = responseParsed.specsValues || [];
                const specDefaults = responseParsed.specDefaults || [];
                const tagFilter = helper.getTagFilter();
                const vp = helper.getVignettePreview();
                const surface = helper.getSurface();

                if (!tag || !tag.id || !tagFilter || !vp) {
                    cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
                    return;
                }

                const updateSelectedTags = (defaultHubPageUrl: string = "") => {
                    const selectedTags = tagFilter.getTagObjs().map((selectedTag) => {
                        if (selectedTag.id == tag.id) {
                            tag.previewSpecValues = specsValues;
                            tag.previewSpecDefaults = specDefaults;
                            tag.previewExtraDefaults = { default_hub_page_url: defaultHubPageUrl };
                            tag.isPreviewDataLoaded = true;
                            return tag;
                        }
                        return selectedTag;
                    });

                    tagFilter.setTagObjs(selectedTags);
                    const nextTagNeedingFetch = selectedTags.filter((selectedTag) => {
                        return selectedTag && selectedTag.id && !selectedTag.isPreviewDataLoaded;
                    })[0];

                    if (nextTagNeedingFetch) {
                        helper.getTagById(nextTagNeedingFetch.id, PREVIEW_CONTAINER_ID);
                    } else {
                        vp.setIndexedValuesForTags(selectedTags);
                        tagFilter.clearInput();
                        cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
                    }
                };

                helper.getListingPageByTag([{ id: tag.id, name: tag.name }], (page: any | null) => {
                    updateSelectedTags(page && typeof page.permalink === "string" ? page.permalink : "");
                });
            });
        };
    }

    public getListingPageByTag(tagsFilter: any[] | null, callback: (item: any | null) => void) {
        try {
            const brand = this.vnAppZone.app.params.idBrand;

            let tagId: any = null;
            if (Array.isArray(tagsFilter) && tagsFilter.length && tagsFilter[0] && tagsFilter[0].id != null) {
                tagId = tagsFilter[0].id;
            }
            if (tagId == null) {
                if (typeof callback === "function") {
                    callback(null);
                }
                return;
            }

            const url: string = `/api/brand/${brand}/config/listing-pages/by-tag/${tagId}/`;
            const params: string[][] = [];
            const key = "getListingPageByTag_forPreview";
            if (this.XHRHdls[key]) {
                this.XHRHdls[key].cancelAndReset();
            }
            this.XHRHdls[key] = new XMLHttpRequestHandler(url, params, this);
            this.XHRHdls[key].onReadyStateFunction = (req2, obj2) => () => {
                const cm = obj2.callerModule;
                if (!cm || typeof cm.manageResponse !== "function") {
                    if (typeof callback === "function") {
                        callback(null);
                    }
                    return;
                }
                cm.manageResponse(req2, cm, () => {
                    try {
                        const res = JSON.parse(req2.request.response);
                        const item = res && res.data ? res.data : null;
                        if (typeof callback === "function") {
                            callback(item);
                        }
                    } catch (e) {
                        if (typeof callback === "function") {
                            callback(null);
                        }
                    }
                });
            };
            this.XHRHdls[key].execute();
        } catch (e) {
            if (typeof callback === "function") {
                callback(null);
            }
        }
    }

    //===============================================
    //article autocomplete and preview article functions
    public getArticlesSuggestion(keyword, idElement) {
        if (this.XHRHdls["getArticlesSuggestion"]) {
            this.XHRHdls["getArticlesSuggestion"].cancelAndReset();
        }

        const subViewModel = { list: { keyword: keyword }, limit: 100, idElement: idElement };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/search/article/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getArticlesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getArticlesSuggestion"].onReadyStateFunction = this.onGetArticlesSuggestionReturn;
        this.XHRHdls["getArticlesSuggestion"].execute();
    }

    public onGetArticlesSuggestionReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }
            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.articles) {
                    const af = helper.getArticleFilter();
                    if (af && typeof af.setOptions === "function") {
                        af.setOptions(responseParsed.data.articles);
                    }
                }
            });
        };
    }

    public updateArticleFilterSelectedValue() {
        const af = this.getArticleFilter();
        const lp = this.getListingPageFilter();
        const vp = this.getVignettePreview();

        const selectedArticles = af.getArticleObjs();
        let allArticles = vp.getAllSelectedArticles();

        const allArticleIds = allArticles.map((article) => String(article.id));
        const articleNeedingFetch = selectedArticles.filter((article) => {
            return article && article.id && allArticleIds.indexOf(String(article.id)) === -1;
        })[0];

        if (articleNeedingFetch) {
            this.getArticleById(articleNeedingFetch.id, PREVIEW_CONTAINER_ID);
            return;
        }

        const selectedArticleIds = selectedArticles.map((article) => String(article.id));
        allArticles = allArticles.filter((article) => {
            return selectedArticleIds.indexOf(String(article.id)) !== -1 || !!article.previewSource;
        });
        vp.setAllSelectedArticles(allArticles);
        vp.setIndexedValuesForArticles(allArticles);
        af.clearInput();
        lp.clearInput();
    }

    public getArticleById(idArticle, idElement) {
        const cm = this.callerModule;
        const surface = this.getSurface();
        if (!idArticle || !surface || !cm || typeof cm.loadingIn !== "function") {
            return;
        }

        cm.loadingIn(surface.builtTemplate.querySelector(`#${idElement}`));

        const idRequest = "getPreviewArticle";
        const idBrand: string = this.vnAppZone.app.params.idBrand;
        if (this.XHRHdls[idRequest]) {
            this.XHRHdls[idRequest].cancelAndReset();
        }
        const usrReq_url: string = `/api/brand/${idBrand}/articles/get/${idArticle}`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON({ idArticle: idArticle })]);
        this.XHRHdls[idRequest] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls[idRequest].onReadyStateFunction = this.onGetArticleByIdReturn;
        this.XHRHdls[idRequest].execute();
    }

    public onGetArticleByIdReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }
            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                const data = responseParsed.data;
                const article = data.article;
                const vp = helper.getVignettePreview();
                const af = helper.getArticleFilter();
                const surface = helper.getSurface();
                if (!article || !article.id || !af || !vp) {
                    cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
                    return;
                }

                //update article display author ids with objects
                article.displayAuthors = data.displayAuthors || [];
                article.brandInfo = data.brandInfo || null;

                //comment counts
                article.commentsCount = data.commentsCount || 0;

                //add new article to the list of all selected articles
                let selectedArticles = vp.getAllSelectedArticles();
                selectedArticles.push(article);

                //remove duplicates from the list of all selected articles
                selectedArticles = selectedArticles.filter((article, index, self) =>
                    index === self.findIndex((t) => t.id === article.id)
                );

                vp.setAllSelectedArticles(selectedArticles);
                vp.setIndexedValuesForArticles(selectedArticles);
                af.clearInput();
                        cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
            });
        };
    }

    //===============================================
    //video autocomplete and preview video functions
    public getVideosSuggestion(keyword, idElement) {
        if (this.XHRHdls["getVideosSuggestion"]) {
            this.XHRHdls["getVideosSuggestion"].cancelAndReset();
        }

        const subViewModel = {
            filters: {
                keywords: keyword,
                ratio: null,
                orientation: null,
                tags: [],
                categories: [],
                contentTypes: [],
            },
            videoPagination: { pageNumber: 1, itemPerPage: 10 },
            orderBy: "dateCreated",
            orderByDirection: "DESC",
        };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/videos/get/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        this.XHRHdls["getVideosSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getVideosSuggestion"].onReadyStateFunction = this.onGetVideosSuggestionReturn;
        this.XHRHdls["getVideosSuggestion"].execute();
    }

    public onGetVideosSuggestionReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }
            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                const videos = responseParsed.paginatedVideos && responseParsed.paginatedVideos.data
                    ? responseParsed.paginatedVideos.data
                    : [];
                const vf = helper.getVideoFilter();
                if (vf && typeof vf.setOptions === "function") {
                    vf.setOptions(videos);
                }
            });
        };
    }

    public updateVideoFilterSelectedValue() {
        const vf = this.getVideoFilter();
        const vp = this.getVignettePreview();
        const selectedVideos = vf && typeof vf.getVideoObjs === "function" ? vf.getVideoObjs() : null;
        if (selectedVideos && selectedVideos.length > 0) {
            vp.setIndexedValuesForVideos(selectedVideos);
        } else if (vp && typeof vp.clearIndexedValuesForVideo === "function") {
            vp.clearIndexedValuesForVideo();
        }
        if (vf && typeof vf.clearInput === "function") {
            vf.clearInput();
        }  
    }

    //===============================================
    //listing page autocomplete and preview listing page functions
    public getListingPagesSuggestion(keyword, idElement): void {

        if( this.XHRHdls["getListingPagesSuggestion"] ){
            this.XHRHdls["getListingPagesSuggestion"].cancelAndReset();
        }

        let filterData = { keyword: keyword };
        let usrReq_url: string = '/api/brand/' + this.vnAppZone.app.params.idBrand + "/config/listing-pages/search/";

        let subViewModel = {pagination: {itemPerPage: 50}, filter: filterData, idElement: idElement};
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getListingPagesSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);

        this.XHRHdls["getListingPagesSuggestion"].onReadyStateFunction = this.onGetListingPagesSuggestionReturn.bind(this, idElement);
        this.XHRHdls["getListingPagesSuggestion"].execute();
    }

    public onGetListingPagesSuggestionReturn(idElement, req, obj) {

        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }
            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.listingPages) {
                    let filter = helper.getListingPageFilter();
                    if(idElement == "hubPageFilter") {
                        filter = helper.getHubPageFilter();
                    }
                    if (filter && typeof filter.setOptions === "function") {
                        filter.setOptions(responseParsed.data.listingPages);
                    }
                }
            });
        };
    }

    public updateListingPageFilterSelectedValue() {
        const lf = this.getListingPageFilter();
        const vp = this.getVignettePreview();
        const selectedListingPage = lf && lf.getTemplateViewModel().listingPageObj() ? lf.getTemplateViewModel().listingPageObj() : null;
        if (selectedListingPage) {
            if (vp && typeof vp.setIndexedValuesForListingPageContext === "function") {
                vp.setIndexedValuesForListingPageContext(selectedListingPage);
            }
            this.getListingPageLatestArticles(selectedListingPage.id);
        }else {
            if (vp && typeof vp.clearIndexedValuesForListingPageContext === "function") {
                vp.clearIndexedValuesForListingPageContext();
            }
            this.removeArticlesFromSource(ARTICLE_SOURCE_LISTING_PAGE);
        }
    }
    
    public getListingPageLatestArticles(idListingPage) {
        const cm = this.callerModule;
        const surface = this.getSurface();
        const vp = this.getVignettePreview();
        if (surface && cm && typeof cm.loadingIn === "function") {
            cm.loadingIn(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
        }

        let limit =  vp.getMaxPlaceholderSlot('article');
        const url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/config/listing-pages/latest-articles/${idListingPage}/`;
        const params: string[][] = [];
        params.push(["data", ko.toJSON({ limit: limit })]);
        const key = "getListingPageLatestArticles";
        if (this.XHRHdls[key]) {
            this.XHRHdls[key].cancelAndReset();
        }
        this.XHRHdls[key] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdls[key].onReadyStateFunction = this.onGetListingPageLatestArticlesReturn;
        this.XHRHdls[key].execute();
    }

    public onGetListingPageLatestArticlesReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }

            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                const articles = responseParsed.data && responseParsed.data.articles ? responseParsed.data.articles : [];
                const surface = helper.getSurface();

                helper.addArticlesFromSource(articles, ARTICLE_SOURCE_LISTING_PAGE);

                if (surface && cm && typeof cm.loadingOut === "function") {
                    cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
                }
            });
        }
    }

    //===============================================
    //author autocomplete and preview author articles functions
    public getUsersSuggestion(keyword, idElement) {
        if (this.XHRHdls["getUsersSuggestion"]) {
            this.XHRHdls["getUsersSuggestion"].cancelAndReset();
        }

        const subViewModel = { list: { keyword: keyword }, idElement: idElement };
        const usrReq_url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/search/user/`;
        const usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)]);
        usrReq_params.push(["isVignettePickerRequest", "true"]);
        this.XHRHdls["getUsersSuggestion"] = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdls["getUsersSuggestion"].onReadyStateFunction = this.onGetUsersSuggestionsReturn;
        this.XHRHdls["getUsersSuggestion"].execute();
    }

    public onGetUsersSuggestionsReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }
            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                if (responseParsed.data && responseParsed.data.users) {
                    const authorFilter = helper.getAuthorFilter();
                    if (authorFilter && typeof authorFilter.setUsers === "function") {
                        authorFilter.setUsers(responseParsed.data.users);
                    }
                }
            });
        };
    }

    public updateAuthorFilterSelectedValue() {
        const authorFilter = this.getAuthorFilter();
        const selectedAuthor = authorFilter && typeof authorFilter.getUserObject === "function" ? authorFilter.getUserObject() : null;
        if (selectedAuthor && selectedAuthor.id) {
            this.getAuthorLatestArticles(selectedAuthor.id);
        } else {
            this.removeArticlesFromSource(ARTICLE_SOURCE_AUTHOR);
        }
    }

    public getAuthorLatestArticles(idUser) {
        const cm = this.callerModule;
        const surface = this.getSurface();
        const vp = this.getVignettePreview();
        if (!idUser || !vp) {
            return;
        }

        const limit = vp.getMaxPlaceholderSlot('article');
        if (limit < 1) {
            return;
        }

        if (surface && cm && typeof cm.loadingIn === "function") {
            cm.loadingIn(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
        }

        const url: string = `/api/brand/${this.vnAppZone.app.params.idBrand}/articles/latest-by-author/${idUser}/`;
        const params: string[][] = [];
        params.push(["data", ko.toJSON({ limit: limit })]);
        const key = "getAuthorLatestArticles";
        if (this.XHRHdls[key]) {
            this.XHRHdls[key].cancelAndReset();
        }
        this.XHRHdls[key] = new XMLHttpRequestHandler(url, params, this);
        this.XHRHdls[key].onReadyStateFunction = this.onGetAuthorLatestArticlesReturn;
        this.XHRHdls[key].execute();
    }

    public onGetAuthorLatestArticlesReturn(req, obj) {
        const helper: vignettePreview_helper = obj;
        const cm = helper.callerModule;
        return function () {
            if (!cm || typeof cm.manageResponse !== "function") {
                return;
            }

            cm.manageResponse(req, cm, function () {
                const responseParsed = JSON.parse(req.request.response);
                const articles = responseParsed.data && responseParsed.data.articles ? responseParsed.data.articles : [];
                const surface = helper.getSurface();

                helper.addArticlesFromSource(articles, ARTICLE_SOURCE_AUTHOR);

                if (surface && cm && typeof cm.loadingOut === "function") {
                    cm.loadingOut(surface.builtTemplate.querySelector(`#${PREVIEW_CONTAINER_ID}`));
                }
            });
        }
    }

    //===============================================
    //hub page autocomplete and preview hub functions
    public updateHubPageFilterSelectedValue() {
        const hf = this.getHubPageFilter();
        const vp = this.getVignettePreview();
        const selectedHubs = hf && typeof hf.getListingPageObjs === "function" ? hf.getListingPageObjs() : [];
        if (selectedHubs && selectedHubs.length > 0) {
            vp.setIndexedValuesForHubs(selectedHubs);
        } else if (vp && typeof vp.clearIndexedValuesForHubs === "function") {
            vp.clearIndexedValuesForHubs();
        }
    }

    //===============================================
    //brand related functions
    public initializeBrandDefaults(): void {
        const idBrand = this.vnAppZone.app.params.idBrand;
        if (!idBrand) {
            return;
        }

        const url = `/api/brand/${idBrand}/tags/vignettes/references/`;

        if (this.XHRHdls["getBrandVignetteReferences"]) {
            this.XHRHdls["getBrandVignetteReferences"].cancelAndReset();
        }

        this.XHRHdls["getBrandVignetteReferences"] = new XMLHttpRequestHandler(url, [], this);
        this.XHRHdls["getBrandVignetteReferences"].onReadyStateFunction = this.onInitializeBrandDefaultsReturn;
        this.XHRHdls["getBrandVignetteReferences"].execute();
    }

    public onInitializeBrandDefaultsReturn(req, obj) {
        const helper: vignettePreview_helper = obj;

        return function () {
            if (!helper.callerModule || typeof helper.callerModule.manageResponse !== "function") {
                return;
            }

            helper.callerModule.manageResponse(req, helper.callerModule, function () {
                const responseParsed = JSON.parse(req.request.response);
                const brandReferences = responseParsed.brand_references || {};
                const brandReferenceLabels = responseParsed.brand_reference_labels || {};
                const vp = helper.getVignettePreview();

                if (vp && typeof vp.setBrandReferences === "function") {
                    vp.setBrandReferences(brandReferences);
                }

                const surface = helper.getSurface();
                if (surface && typeof surface.setBrandDefaults === "function") {
                    surface.setBrandDefaults(brandReferences, brandReferenceLabels);
                }
            });
        };
    }
}   



// WEBPACK FOOTER //
// ./js/modules/vignettePreview_helper.ts